import { useState } from "react";
import { VerlaufButton, VerlaufKomplett } from "./LinienführungAnlegenCss";
var MonitorApi = require('monitor-api');

export default function AuswahlHinrichtungNeueInfrastruktur({ hrCollection, setHrCollection, bhfListe, strInstance, strVerlInstance }) {

    const [filteredHrBhfListe, setFilteredHrBhfListe] = useState([]);
    const [streckenListe, setStreckenListe] = useState({
        suchanfrage: {
            idStartBhf: undefined,
            idEndBhf: undefined
        },
        allStrecken: [],
        showVerlauf: {}
    });

    function handleNeueStreckeChange(e) {
        e.preventDefault();
        setHrCollection({
            ...hrCollection,
            neueStrecke: !hrCollection.neueStrecke,
            bisherigeStrNutzen: false,
            hrHalte: {},
            hrVerlauf: [],
            hrStreckenId: undefined,
            mirrored: undefined
        });

        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                idStartBhf: undefined,
                idEndBhf: undefined
            },
            allStrecken: [],
            showVerlauf: {}
        });
    }

    function handleStartBhfChange(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                ...streckenListe.suchanfrage,
                idStartBhf: e.target.value
            }
        });

        filterBhfListe(e.target.value);
    }

    function handleEndBhfChange(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                ...streckenListe.suchanfrage,
                idEndBhf: e.target.value
            }
        });
    }

    function filterBhfListe(idStartBhf) {
        strInstance.getPossibleEnds(idStartBhf, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load bhfListe', data);
                setFilteredHrBhfListe(data);
            }
        })
    }

    function handleStreckenLoad(data) {
        let verlaufShow = {};
        data.forEach(str => verlaufShow[str.id_strecke] = false);
        setStreckenListe({
            ...streckenListe,
            allStrecken: data,
            showVerlauf: verlaufShow
        });
    }

    function handleVerlaufShow(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            showVerlauf: {
                ...streckenListe.showVerlauf,
                [e.target.value]: !streckenListe.showVerlauf[e.target.value]
            }
        });
    }
    const loadStrecken = (event) => {
        event.preventDefault();
        setHrCollection({
            ...hrCollection,
            hrHalte: {},
            hrVerlauf: [],
            hrStreckenId: undefined,
            mirrored: undefined,
            bisherigeStrNutzen: false
        });

        var startEnd = new MonitorApi.StreckeVonBis();
        startEnd.id_eins = streckenListe.suchanfrage.idStartBhf;
        startEnd.id_zwei = streckenListe.suchanfrage.idEndBhf;
        strVerlInstance.searchStreckenverlaufStreckenverlaufSuchePatch(startEnd, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load Strecken HR', data);
                handleStreckenLoad(data);
            }
        })
    }

    function updateRadios(e) {
        let specificStrecke = streckenListe.allStrecken
            .filter(str => str.id_strecke === parseInt(e.target.value))[0]
            .strecke;
        specificStrecke.forEach(str => str.verlauf = false);
        let halte = {};
        specificStrecke.forEach(station => halte[station.pos] = true)
        setHrCollection({
            ...hrCollection,
            bisherigeStrNutzen: false,
            hrVerlauf: specificStrecke,
            hrHalte: halte,
            hrStreckenId: parseInt(e.target.value),
            mirrored: streckenListe.allStrecken
                .filter(str => str.id_strecke === parseInt(e.target.value))[0]
                .mirrored
        });
    }

    const orderingVerlauf = (ext_verlauf, mirror) => {
        if (mirror) {
            return [...ext_verlauf].sort((a, b) => a.pos < b.pos)
        } else {
            return [...ext_verlauf].sort((a, b) => a.pos > b.pos)
        }
    }

    const updateVerlauf = (e) => {
        e.preventDefault();
        handleVerlaufChange(e.target.id);
    }

    function handleVerlaufChange(bhfPos) {
        let completeStation = hrCollection.hrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        let currentState = completeStation.verlauf;
        completeStation.verlauf = !currentState;
        if (!currentState) {
            // nur wenn verlauf auf ja, dann halt auch
            handleHalteChange(bhfPos, true);
        }
        let completeVerlauf = hrCollection.hrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setHrCollection({
            ...hrCollection,
            hrVerlauf: completeVerlauf
        });
    }

    function updateHalte(e) {
        handleHalteChange(e.target.value, e.target.checked);
    }

    function handleHalteChange(bhfPos, newState) {
        let currentHalte = hrCollection.hrHalte;
        currentHalte[bhfPos] = newState;

        if (!newState) {
            // wenn auf nein, dann auch verlauf nein
            setVerlaufFalse(bhfPos);
        }

        setHrCollection({
            ...hrCollection,
            hrHalte: currentHalte
        });
    }

    function setVerlaufFalse(bhfPos) {
        let completeStation = hrCollection.hrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        completeStation.verlauf = false;
        let completeVerlauf = hrCollection.hrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setHrCollection({
            ...hrCollection,
            hrVerlauf: completeVerlauf
        });
    }

    return (
        <div>
            <button className="ausklappsie" onClick={(e) => handleNeueStreckeChange(e)}>
                <label>{hrCollection.neueStrecke ? <span>&#8722; </span> : <span>&#43; </span>} neue Strecke hinzufügen:</label>
            </button>
            {hrCollection.neueStrecke && <section className="ausklappsie-klappe">
                <h5>Strecke auswählen:</h5>
                <label>Start-Bahnhof:</label>
                <select onChange={(event) => handleStartBhfChange(event)}>
                    <option hidden={true}>---Auswahl treffen---</option>
                    {bhfListe.map(bhf => <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>)}
                </select>

                <label>End-Bahnhof:</label>
                <select onChange={(event) => handleEndBhfChange(event)}>
                    <option hidden={true}>---Auswahl treffen---</option>
                    {filteredHrBhfListe.map(bhf => <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>)}
                </select>
                {<button disabled={!streckenListe.suchanfrage.idStartBhf || !streckenListe.suchanfrage.idEndBhf}
                    onClick={e => loadStrecken(e)}>Strecken suchen</button>}
                {/* <p>{JSON.stringify(streckenListe)}</p> */}
                <div>
                    {streckenListe.allStrecken.map(strecke =>
                        <fieldset key={strecke.id_strecke}>
                            <label>
                                <input type="radio" value={strecke.id_strecke} name="strecke"
                                    onChange={event => updateRadios(event)} />
                                Anzahl Bahnhöfe: {strecke.strecke.length}
                            </label>
                            {hrCollection.hrStreckenId !== strecke.id_strecke && <>
                                <br></br>
                                <button style={{ margin: "1em 2em" }} value={strecke.id_strecke}
                                    onClick={(e) => handleVerlaufShow(e)}>
                                    {streckenListe.showVerlauf[strecke.id_strecke] ? <span>&#8722; </span> : <span>&#43; </span>}
                                    vollständiger Verlauf</button>
                            </>}
                            {streckenListe.showVerlauf[strecke.id_strecke] &&
                                orderingVerlauf(strecke.strecke, strecke.mirrored).map(bhf => <label key={bhf.pos}>-{bhf.pos}: {bhf.bhf}-</label>)}
                            {hrCollection.hrStreckenId === strecke.id_strecke &&
                                <VerlaufKomplett>
                                    <thead>
                                        <tr>
                                            <th>in Verlaufsbeschreibung</th>
                                            <th>Halt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderingVerlauf(strecke.strecke, strecke.mirrored).map(bhf =>
                                            <tr key={bhf.pos}>
                                                {/* verlauf */}
                                                <td>
                                                    <VerlaufButton id={bhf.pos} value={bhf.pos} onClick={(e) => updateVerlauf(e)}
                                                        className={hrCollection.hrVerlauf.filter(station => station.pos === bhf.pos)[0].verlauf ? "active" : "inactive"}>
                                                        <span id={bhf.pos}>{bhf.pos}: </span>{bhf.bhf}</VerlaufButton>
                                                </td>
                                                {/* halt */}
                                                <td>
                                                    <input type="checkbox" value={bhf.pos} onChange={(e) => updateHalte(e)}
                                                        checked={hrCollection.hrHalte[bhf.pos]} />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </VerlaufKomplett>
                            }
                        </fieldset>)
                    }
                </div>
            </section>}
        </div>
    )
}